import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaAi = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(5, 5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.212 20.8103C20.8916 20.5876 21.3507 19.9654 21.3507 19.2631C21.3507 18.6974 21.0527 18.1831 20.5809 17.8888L20.2124 17.7149C16.4613 16.483 13.5159 13.6015 12.2556 9.9314C12.0277 9.26619 11.3914 8.81873 10.6753 8.81873C9.95933 8.81873 9.3231 9.26609 9.09519 9.93118C7.83497 13.6012 4.88965 16.4829 1.13862 17.7148C0.45908 17.9375 0 18.5597 0 19.262C0 19.9641 0.458933 20.5863 1.13828 20.8091C4.88947 22.041 7.83494 24.9226 9.09519 28.5928C9.3231 29.2579 9.95934 29.7052 10.6753 29.7052C11.3913 29.7052 12.0277 29.2574 12.2556 28.5923C13.5159 24.9226 16.4611 22.0422 20.212 20.8103ZM17.8255 19.2625C14.6856 17.8009 12.15 15.3034 10.6753 12.1941C9.20081 15.303 6.66573 17.8003 3.52633 19.262C6.66573 20.7237 9.20082 23.221 10.6753 26.3299C12.1501 23.2206 14.6857 20.7239 17.8255 19.2625Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.8605 7.46141C29.2889 7.32285 29.5784 6.93568 29.5784 6.49871C29.5784 6.14675 29.3905 5.82675 29.0931 5.64361L28.8608 5.5354C28.6187 5.45696 28.3821 5.36777 28.1513 5.2684C28.1507 5.26814 28.15 5.26787 28.1494 5.2676C28.1427 5.26472 28.1361 5.26183 28.1294 5.25894C28.1293 5.25892 28.1293 5.25889 28.1292 5.25887C26.1156 4.38476 24.5551 2.73478 23.8445 0.692333C23.7009 0.27842 23.2997 0 22.8483 0C22.3969 0 21.9958 0.27836 21.8521 0.692191C21.1416 2.7344 19.5814 4.38425 17.5682 5.25848C17.5681 5.25851 17.5681 5.25853 17.568 5.25855C17.5609 5.26167 17.5537 5.26477 17.5465 5.26786C17.5461 5.26803 17.5457 5.26821 17.5453 5.26838C17.3146 5.36773 17.0779 5.4569 16.836 5.53533C16.4076 5.67389 16.1182 6.06106 16.1182 6.49803C16.1182 6.93493 16.4075 7.32204 16.8358 7.46065C17.0777 7.53906 17.3143 7.62822 17.545 7.72754C17.5456 7.72781 17.5462 7.72808 17.5469 7.72834C17.5539 7.73139 17.561 7.73444 17.568 7.7375C17.5681 7.73753 17.5681 7.73755 17.5682 7.73758C19.5814 8.61181 21.1416 10.2617 21.8521 12.3039C21.9958 12.7177 22.3969 12.9961 22.8483 12.9961C23.2997 12.9961 23.7009 12.7174 23.8445 12.3036C24.553 10.2676 26.1059 8.62211 28.1104 7.74603C28.1118 7.74542 28.1132 7.74481 28.1146 7.74419C28.1195 7.74208 28.1243 7.73997 28.1292 7.73786C28.136 7.73489 28.1429 7.73192 28.1498 7.72897C28.3809 7.62938 28.6181 7.54 28.8605 7.46141ZM25.5742 6.49829C24.5026 5.78222 23.576 4.87229 22.8483 3.8146C22.1206 4.87216 21.1942 5.782 20.1228 6.49803C21.1942 7.21408 22.1207 8.12393 22.8483 9.18152C23.576 8.12393 24.5027 7.2142 25.5742 6.49829Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaAi.displayName = 'LlamaAi';
